import React from 'react';
import { Space, Tag, Typography, theme } from 'antd';
import { getZoneStyle, type ControlTowerZone } from './controlTowerTheme';

const { Text } = Typography;

export interface ControlTowerSubQueuePanelProps {
  zone: ControlTowerZone;
  title: string;
  count: number;
  children: React.ReactNode;
}

export const ControlTowerSubQueuePanel: React.FC<ControlTowerSubQueuePanelProps> = ({
  zone,
  title,
  count,
  children,
}) => {
  const { token } = theme.useToken();
  const zoneStyle = getZoneStyle(token, zone);

  return (
    <div style={zoneStyle.bodyStyle}>
      <Space style={{ marginBottom: 8, width: '100%', justifyContent: 'space-between' }} wrap>
        <Text strong>{title}</Text>
        <Tag color={count > 0 ? 'processing' : 'default'}>{count} ready</Tag>
      </Space>
      {children}
    </div>
  );
};
